import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRemove = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgRemove" data-sentry-source-file="remove.tsx">
    <g clipPath="url(#remove_svg__a)" data-sentry-element="g" data-sentry-source-file="remove.tsx">
      <path fill="#263E6A" d="M5.5 12.5v-1h13v1z" data-sentry-element="path" data-sentry-source-file="remove.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="remove.tsx">
      <clipPath id="remove_svg__a" data-sentry-element="clipPath" data-sentry-source-file="remove.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="remove.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgRemove;